<template>
  <div v-if="params && params.data && !params.data.is_success">
    <v-tooltip
      right
      color="error"
      v-if="Object.keys(params.data.error).length > 0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="red" v-bind="attrs" v-on="on"> mdi-information </v-icon>
      </template>
      <span>
        <span
          v-for="[key, value, index] in Object.entries(params.data.error)"
          :key="index"
          class="text-capitalize"
        >
          <span v-if="value && !Array.isArray(value) && typeof value === typeof {}">
            <span  v-for="[objectKey, objectValue, objectIndex] in Object.entries(value)" :key="objectIndex">
               <span> {{ objectKey.replace(/_/g, "  ") }} - </span>{{ objectValue[0] }}   <br />
            </span>
          </span>
          <span v-else> 
            <span>{{ key.replace(/_/g, "  ") }} - {{ value[0] }}</span><br />
          </span>
        </span>
      </span>
    </v-tooltip>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {};
  },
  mounted() {},
};
</script>
  